import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md border-b border-sage-dark py-4' : 'bg-transparent py-6'}`} data-id="element-104">
      <div className="container mx-auto px-6 max-w-6xl flex items-center justify-between" data-id="element-105">
        <a href="#" className="text-xl font-bold tracking-tighter text-forest" data-id="element-106">
          GUT LABS
          <sup className="text-[0.55em] font-medium ml-0.5 tracking-tight" data-id="element-107">
            TM
          </sup>
        </a>

        <motion.a href="https://vyralea.com/cart/55754971611476:1?checkout" className="relative inline-flex items-center gap-2 bg-[#1F4A3E] text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full text-xs md:text-sm font-bold hover:bg-[#163530] transition-colors shadow-lg shadow-[#1F4A3E]/25" animate={{
        boxShadow: ['0 6px 18px rgba(31, 74, 62, 0.25)', '0 6px 28px rgba(31, 74, 62, 0.55)', '0 6px 18px rgba(31, 74, 62, 0.25)']
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        repeatDelay: 3,
        ease: 'easeInOut'
      }} data-id="element-108">
          {/* Soft glow ring */}
          <motion.span aria-hidden className="absolute inset-0 rounded-full bg-[#1F4A3E]" animate={{
          opacity: [0, 0.35, 0],
          scale: [1, 1.18, 1.25]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          repeatDelay: 3,
          ease: 'easeOut'
        }} style={{
          zIndex: -1
        }} data-id="element-109" />
          <span className="relative" data-id="element-110">EMPEZAR PROTOCOLO (9,90€)</span>
          <ArrowDown className="relative w-3.5 h-3.5" strokeWidth={2.5} data-id="element-111" />
        </motion.a>
      </div>
    </motion.header>;
}